export default [
  {
    path: '/cadastro/admin/:uuid',
    name: 'register-admin',
    component: () => import('@/views/pages/register/register.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
    },
  },
  {
    path: '/journey/admin',
    name: 'journei-admin',
    component: () => import('@/views/pages/register/journey.vue'),
  },
]
